import type { PracticeScreen } from '../components';
import { useLocation } from 'react-router-dom';

export const useIsPath = (practiceScreen: PracticeScreen): boolean => {
    const location = useLocation();
    return location.pathname === `/${practiceScreen}`;
};
